// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__29JM7","imageUploader":"EGiftCard_imageUploader__3mtU_"};